/* This file is autogenerated, see readme.md for instructions */
import UntilNowAltSvgIcon from '@bloomreach/banana-theme/icons/until-now-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UntilNowAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UntilNowAltSvgIcon />
    </Icon>
  );
});

UntilNowAltIcon.displayName = 'UntilNowAltIcon';

export default UntilNowAltIcon;
